import { FC } from 'react'
import { WidgetComponentStyled } from './styled-components'

const About: FC = ({

}) => {
  return <WidgetComponentStyled title='About'>
    
  </WidgetComponentStyled>
}

export default About